import { styled, TextareaAutosize } from "@mui/material";

import { BORDER_COLORS } from "../../constants";

export const Textarea = styled(TextareaAutosize)(() => ({
  borderRadius: 4,
  position: "relative",
  backgroundColor: "#FFFFFF",
  border: "1px solid",
  borderColor: BORDER_COLORS.default,
  fontSize: 12,
  fontWeight: 400,
  width: "100%",
  boxShadow: "none",
  height: "32px",
  padding: "2px",
  boxSizing: "border-box",
  "&:focus, &:hover, &:active, &:focus-visible": {
    borderColor: BORDER_COLORS.focused,
    outline: "none",
  },
}));

export default Textarea;
